import React, {
  createContext,
  useState,
  useEffect,
  useLayoutEffect,
} from "react";
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar } from '@mui/material';
// components
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { useDispatch, useSelector } from "react-redux";
// ----------------------------------------------------------------------
import { AuthContext } from "../../../Auth/components/AuthContext";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  Link,
  useNavigate, useLocation
} from "react-router-dom";
const MENU_OPTIONS = [

  // {
  //   label: 'Anasayfa',
  //   linkTo: '/home',
  // }
  // ,
  // {
  //   label: 'Profil',
  //   linkTo: '/Account',
  // },
  // {
  //   label: 'Şifre Değiştir',
  //   linkTo: '/ChangePassword',
  // },
  // {
  //   label: 'Ayarlar',
  //   linkTo: '/',
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {


  let navigate = useNavigate();
  

  const dispatch = useDispatch();
  const [open, setOpen] = useState(null);
  const { authUser, logoutUser } = React.useContext(AuthContext);
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = (url) => {
    setOpen(null);
    console.log("url:",url);
    if(url)
    navigate(url)
    
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
      <AccountCircleIcon></AccountCircleIcon>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={()=>handleClose("")}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
          {authUser.email}
          </Typography>
          {/* <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {authUser.email}
          </Typography> */}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label}  to={option.linkTo} onClick={()=>handleClose(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem sx={{ m: 1 }} onClick={() => logoutUser()}>Çıkış Yap</MenuItem>
      </MenuPopover>
    </>
  );
}
